import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import Button from '../ui/Button';
import AuthLayout from './AuthLayout';

const { FiArrowLeft, FiMail } = FiIcons;

const VerifyEmail = () => {
    return (
        <AuthLayout
            title="Verify your email"
            subtitle="We've sent a link to your email address."
        >
            <div className="text-center space-y-6">
                <div className="w-20 h-20 bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 rounded-2xl flex items-center justify-center mx-auto">
                    <FiMail size={40} />
                </div>

                <p className="text-gray-600 dark:text-gray-400">
                    Please click on the link we sent to verify your account. If you didn't receive it, we can resend it.
                </p>

                <div className="space-y-3">
                    <Button className="w-full">
                        Open Email App
                    </Button>
                    <Button variant="secondary" className="w-full">
                        Resend verification link
                    </Button>
                </div>

                <Link to="/login" className="inline-flex items-center gap-2 text-sm font-semibold text-gray-600 dark:text-gray-400 hover:text-indigo-600 transition-colors">
                    <FiArrowLeft /> Back to login
                </Link>
            </div>
        </AuthLayout>
    );
};

export default VerifyEmail;